import {
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@hiver/hiver-ui-kit";

const ConversationTableHeader = () => {
  return (
    <TableHead
      sx={{
        "& .MuiTableCell-root": { backgroundColor: "gray.gray6" },
      }}
    >
      <TableRow>
        <TableCell
          sx={{
            width: "200px",
          }}
        >
          <Typography variant="h3">Conversations</Typography>
        </TableCell>
        <TableCell sx={{ width: "70px" }}>
          <Typography variant="h3">AI Actions</Typography>
        </TableCell>
        <TableCell>
          <Typography variant="h3">AI Test Results</Typography>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default ConversationTableHeader;
